module.exports = __webpack_public_path__ + "static/media/parachute.f29dba08.png";